const RRHH = "postulados_rrhh@sitiouno.com";
const SU = "noreply@sitiouno.com";

export { RRHH, SU };
